// src/components/ui/notifications/index.tsx
import { Box } from '@mui/material'
import { Notification } from './notification'
import { useNotifications } from './notifications-store'

export const Notifications = () => {
  const { notifications, dismissNotification } = useNotifications()

  return (
    <Box
      aria-live='assertive'
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: 5000,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        pointerEvents: 'none', // 背景はクリック不可
        '@media (max-width: 639px)': {
          top: 16,
          left: 16,
          right: 16,
        },
      }}>
      {notifications.map((notification) => (
        <Notification
          key={notification.id}
          notification={notification}
          onDismiss={dismissNotification}
        />
      ))}
    </Box>
  )
}
